import { log } from "./log";

type MarkData = {
  id: string;
  logData: MarkDetail["logData"];
};

const marks: Record<string, MarkData | undefined> = {};

export type MarkDetail = {
  name: string;
  logData?: Record<string, unknown>;
  end?: boolean;
};

export const mark = ({ end, name, logData }: MarkDetail): void => {
  const markData = marks[name];
  if (!name || !markData !== !end) {
    return;
  }

  if (!markData) {
    const id = `${name}-${window.performance.now()}`;
    marks[name] = { id, logData };
    window.performance.mark(`${id}-start`);
    return;
  }
  const startName = `${markData.id}-start`;
  const endName = `${markData.id}-end`;
  window.performance.mark(endName);
  marks[name] = undefined;

  const data = { ...markData.logData, ...logData };
  performance.measure(name, startName, endName);
  log({ ...performance.getEntriesByName(name).pop()!.toJSON(), data, event: "measure" });
};
